import { WORKPLANTABLECOLUMNSALL_SUCCESS } from "../../Constant/ApaManagement/WorkplanTableColumnsAllConstant";


export const getWorkplanTableColumnsAllReducer = (
  state = { workplantablecolumnsall: [] },
  action
) => {
   
  switch (action.type) {
    case WORKPLANTABLECOLUMNSALL_SUCCESS:
      return {
        ...state,
        loading: false,
        workplantablecolumnsall: action.payload,
      };

    default:
      return state;
  }
};
